import { IPayLinkCartItem } from '../context/PayLinkCartContext';

export const formatPaylinkCart = (cart: IPayLinkCartItem[]) => {
  const formattedCart = cart.map((cartItem: IPayLinkCartItem) => {
    return {
      name: cartItem.name,
      price: cartItem.price,
      quantity: cartItem.quantity,
      sku: cartItem.sku,
      productURN: cartItem.productCatalogueItemUniqueReferenceNumber,
      productCategoryURN: cartItem.categoryUniqueReferenceNumber,
      productVariantURN: cartItem.variantUniqueReferenceNumber,
      productVariantImageUrl: cartItem.productImages[0].documentAbsoluteUri.trim(),
      onlineConsultationRequired: cartItem.onlineConsultationRequired,
      cartItemAccessories: [],
    };
  });

  return formattedCart;
};
